<template>
    <span class="input-date-container">
        <input
            :class="cssClass"
            type="text"
            :id="id"
            :value="value"
            @change="onChange($event.target.value)"
            @blur="onBlur($event.target.value)"
            v-if="!hideInput"
        >
        <slot></slot>
    </span>
</template>

<script>
const Pikaday = require('pikaday');
const moment = require('moment');
export default {

    name: 'InputDate',

    date: null,

    props: {
        value: '',
        id: {
            type: String,
            default: () => { return 'input-' + Math.floor(Math.random() * 1000000000); }
        },
        hideInput: {
            type: Boolean,
            default: false
        },
        isBootstrap: {
            type: Boolean,
            default: false
        },
        isBulma: {
            type: Boolean,
            default: true
        },
        inputSize: {
            type: String,
            default: ''
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD',
        },

        // Pikaday specific options
        minDate: Date,
        maxDate: Date,
        yearRange: Array,
    },

    computed: {
        cssClass() {
            const classes = []
            if (this.isBootstrap) {
                classes.push('form-control')
                if(this.inputSize) {
                    classes.push('input-' + this.inputSize)
                }
            }
            if (this.isBulma) {
                classes.push('input')
                if(this.inputSize) {
                    classes.push('is-' + this.inputSize)
                }
            }

            return classes.join(' ')
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.init()
        });
    },
    methods: {
        init() {
            let options = {
                field: this.$el,
                firstDay: 1,
                i18n: {
                    previousMonth : 'Forrige',
                    nextMonth     : 'Næste',
                    months        : ['Januar','Februar','Marts','April','Maj','Juni','Juli','August','September','Oktober','November','December'],
                    weekdays      : ['Søndag','Manday','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
                    weekdaysShort : ['Sø','Ma','Ti','On','To','Fr','Lø']
                },
                showWeekNumber: true,
                onSelect: (value) => {
                    this.$emit('select', this.dateValue(value))
                    this.$emit('input', this.dateValue(value))
                },
            }

            if (this.format) {
                options.format = this.format
            }
            if (this.minDate) {
                options.minDate = this.minDate
            }
            if (this.maxDate) {
                options.maxDate = this.maxDate
            }
            if (this.yearRange) {
                options.yearRange = this.yearRange
            }

            this.date = new Pikaday(options)
        },

        dateValue(value) {
            if (value) {
                return moment(value).format(this.format)
            }
            return value
        },

        onChange(value) {
            this.$emit('input', this.dateValue(value))
        },

        onBlur(value) {
            this.$emit('blur', this.dateValue(value))
        },
    }

}
</script>
